import Image from 'next/image';

import { staticMediaStoreBaseURL } from '@/config/common';
import { trustedPartners } from '@/config/landingPage';
import { useIsMobile } from '@/lib/screenResolution';

const TrustedPartners = () => {
  const [isMobile] = useIsMobile();

  return (
    <section className='w-full overflow-hidden py-5 xs:py-6 sm:py-10'>
      <div className='text-center mb-8'>
        <div className='text-base xs:text-lg sm:text-xl md:text-2xl font-semibold'>
          <span className='bg-brand-gradient bg-clip-text text-transparent'>
            Trusted by Top Partners
          </span>
          <div className='flex justify-center mt-2 gap-2'>
            <div className='h-1 w-20 bg-brand-gradient rounded-full' />
            <div className='h-1 w-5 bg-brand-gradient rounded-full' />
          </div>
        </div>
      </div>
      <div className='relative overflow-hidden'>
        <div className='flex w-max animate-marquee space-x-3 xs:space-x-4 sm:space-x-4 md:space-x-6'>
          {Array(2)
            .fill(null)
            .map((_, loopIndex) =>
              trustedPartners.map(({ alt, url }, index) => (
                <div
                  key={`${alt}-${loopIndex}-${index}`}
                  className='flex items-center justify-center'
                >
                  <Image
                    alt={alt}
                    className='object-contain'
                    height={0}
                    style={{
                      height: isMobile ? 48 : 80,
                      width: isMobile ? 96 : 160
                    }}
                    src={`${staticMediaStoreBaseURL}${url}`}
                    unoptimized
                    width={0}
                  />
                </div>
              ))
            )}
        </div>
      </div>
    </section>
  );
};

export default TrustedPartners;
